var _dec, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { assert } from '@ember/debug';
import { computed } from '@ember/object';
import { PromiseObject } from '@ember-data/store/-private';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

const Extended = PromiseObject;

/**
 @module @ember-data/model
 */

/**
  A PromiseBelongsTo is a PromiseObject that also proxies certain method calls
  to the underlying belongsTo model.
  Right now we proxy:
    * `reload()`
  @class PromiseBelongsTo
  @extends PromiseObject
  @private
*/
let PromiseBelongsTo = (_dec = computed(), _class = class PromiseBelongsTo extends Extended {
  // we don't proxy meta because we would need to proxy it to the relationship state container
  //  however, meta on relationships does not trigger change notifications.
  //  if you need relationship meta, you should do `record.belongsTo(relationshipName).meta()`
  get meta() {
    // eslint-disable-next-line no-constant-condition
    if (1) {
      assert('You attempted to access meta on the promise for the async belongsTo relationship ' + `${this.get('_belongsToState').modelName}:${this.get('_belongsToState').key}'.` + '\nUse `record.belongsTo(relationshipName).meta()` instead.', false);
    }
    return;
  }
  async reload(options) {
    assert('You are trying to reload an async belongsTo before it has been created', this.content !== undefined);
    let {
      key,
      legacySupport
    } = this._belongsToState;
    await legacySupport.reloadBelongsTo(key, options);
    return this;
  }
}, _applyDecoratedDescriptor(_class.prototype, "meta", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "meta"), _class.prototype), _class);
export default PromiseBelongsTo;